const setErrorMessage = async (message) => {

    document.getElementById("errordiv").innerText = message;

    setTimeout(function () {
        const errordiv = document.getElementById("errordiv")
        if (errordiv !== null) {
            errordiv.innerText = "";
        }
    }, 10000);
}

const settopMessage = async (message) => {
    document.getElementById("messagetopdiv").innerText = message;
    setTimeout(function () {
        const messagediv = document.getElementById("messagetopdiv")
        if (messagediv !== null) {
            messagediv.innerText = "";
        }
    }, 10000);
}

const cleartopMessage = async () => {
    document.getElementById("messagetopdiv").innerText = "";

}
//loadingmessage
const setLoading = async (message) => {
    if(message === null || message === undefined)
        message = "Even geduld aub." 
    console.log(message)
    if( document.getElementById("checktext").innerHTML !== message)
        document.getElementById("checktext").innerHTML = message;

    if( document.getElementById("coverAllmessage") != null)
        document.getElementById("coverAllmessage").style.display = "block";
    document.getElementById("loadingmessage").style.display = "block";
    document.getElementById("checktext").style.display = "block";

}
const clearLoading = async () => {
    document.getElementById("checktext").innerText = "";
    if( document.getElementById("coverAllmessage") != null)
        document.getElementById("coverAllmessage").style.display = "none";
    document.getElementById("loadingmessage").style.display = "none";
    document.getElementById("loadingmessage").style.display = "none";

}
const setMessage = async (message) => {
    if(message === null || message === undefined)
        message = "Even geduld aub." 
    if( document.getElementById("messagetext").innerHTML !== message)
        document.getElementById("messagetext").innerHTML = message;

    if( document.getElementById("coverAllmessage") != null)
        document.getElementById("coverAllmessage").style.display = "block";
    document.getElementById("messagetext").style.display = "block";
    document.getElementById("messagediv").style.display = "block";
     
    //document.getElementById("messagediv")
}
const setHTMLMessage = async (message) => {
    document.getElementById("messagetext").innerHTML = message;
    document.getElementById("messagetext").style.display = "block";
    if( document.getElementById("coverAllmessage") != null)
        document.getElementById("coverAllmessage").style.display = "block";
    document.getElementById("messagediv").style.display = "block";
}
const clearMessage = () => {
    document.getElementById("messagetext").innerText = "";
    if( document.getElementById("coverAllmessage") != null)
        document.getElementById("coverAllmessage").style.display = "none";
    document.getElementById("messagediv").style.display = "none";
    document.getElementById("messagetext").style.display = "none";
}

export { setErrorMessage, setMessage, clearMessage,setHTMLMessage,settopMessage,cleartopMessage, setLoading, clearLoading }